import Project1 from "../../assets/project1.jpg";
import Project2 from "../../assets/project2.jpg";


export const projectsData = [
    {
        id: 1,
        image: Project1,
        title: "Production Tracking App",
        category: "FullStack",
        repoLink: "https://github.com/Vigneshshankaran/Production-Tracking-App",
        liveLink: "https://seasonsweetbox.com/login"
    },
    {
        id: 2,
        image: Project2,
        title: "Food Delivery App",
        category: "FullStack",
        repoLink: "https://github.com/Vigneshshankaran/food-delivery-app",
        liveLink: "https://devapizzashop.netlify.app/"
    },
];

export const projectsNav = [
    {
        name: "All",
    },
    {
        name: "FullStack",
    },
    {
        name: "Frontend",
    },
    {
        name: "Backend",
    },
];